import { useLocation, useParams, useSearchParams } from 'react-router-dom';

import {
  DE_DIRECT_BASE_PATHNAME,
  IWOCA_AFFILIATE_TAG,
  UK_DIRECT_BASE_OB_LINK_PATHNAME,
  UK_DIRECT_BASE_PATHNAME,
} from '../constants';
import logger from '../utils/logger';

export function useSignupParams() {
  const { affiliateTag } = useParams();
  const { pathname } = useLocation();

  const isDirectCustomer =
    pathname.includes(UK_DIRECT_BASE_OB_LINK_PATHNAME) ||
    affiliateTag === UK_DIRECT_BASE_PATHNAME ||
    affiliateTag === DE_DIRECT_BASE_PATHNAME;

  const normaliseAffiliateTag = (): string => {
    if (isDirectCustomer) {
      return IWOCA_AFFILIATE_TAG;
    }

    if (!affiliateTag) {
      logger.error('Failed to normalise affiliate tag', {
        error: 'No affiliate tag found',
      });

      return IWOCA_AFFILIATE_TAG;
    }

    return affiliateTag;
  };

  const [searchParams] = useSearchParams();
  const fromCampaign = searchParams.get('from');
  const referredAmount = searchParams.get('amount');
  const referredOfferId = searchParams.get('offer_id');

  return {
    rawAffiliateParam: affiliateTag,
    affiliateTag: normaliseAffiliateTag(),
    isDirectCustomer,
    isPartnerCustomer: !isDirectCustomer,
    fromCampaign,
    referredAmount,
    referredOfferId,
  };
}
